<template lang="pug">
.case-container
  .case-content
    .case-case__title
        div(
          style="width:4px;height:80px;background-color: #478bca;"
        )
        .title__content
          span {{ $t('案例分享：格南登福') }}
          span {{ $t('格南登福工业集团是世界领先的空气压缩和真空产品供应商。') }}
    .case-case__summary
      div(
        style="margin-right: 300px"
      )
        i.iconfont.iconhangye
        span {{ $t('广告主行业：工业机械') }}

      div
        i.iconfont.iconbumen
        span {{ $t('涉及部门：市场部') }}
    .case-case__content__item
        .content__title {{ $t('案例简介：') }}
        .content {{ $t('为格南登福提供SEM服务，增加品牌曝光，提升转化。') }}

    .case-case__content__item
        .content__title {{ $t('客户当前痛点：') }}
        .content {{ $t('初期投放SEM效果不佳，没有足够的曝光以及转化。') }}
    .case-case__content__item
        .content__title {{ $t('复歌解决方案：') }}
        .content {{ $t('整理初期投放内容以及数据分析，根据现状以及客户的目标提出新的执行方案。') }}
        .content 1）{{ $t('关键词：根据客户最新的产品线，整合拓展关键词。') }}
        .content 2）{{ $t('创意文案：分析用户的受众，描述撰写更能够吸引受众的创意文案。 Channel及Funnel分析。') }}
        .content 3）{{ $t('投放总结：定期分析账户数据，根据数据的变化及时调整并优化账户。') }}
    .case-case__content__item
        .content__title {{ $t('最终结果：') }}
        .content {{ $t('为客户拓展搜索引擎渠道，由最初的百度渠道拓展到百度、360以及神马，几乎覆盖目前国内市场中所有流量较大的搜索引擎。每日约为客户带来1000次引流，20-30次有效转化，提高了客户品牌的曝光量同时增加了转化数量。') }}
  contact
</template>"
<script>
import Contact from '@/components/Contact'
export default {
  components: {
    Contact
  }
}
</script>
